var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"red-icon flex items-center justify-center",style:(_vm.iconStyle)},[_c('img',{staticStyle:{"width":"50%","height":"50%"},attrs:{"src":_vm.iconURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }